import { Card, Container } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import AuthorizedContent from 'components/authorized-content';
import { ManageCompanySettings } from 'pages/admin/company-management/company-details/manage-company-settings';
import BackToAnywhere from 'pages/shared/back-to-anywhere';
import { UserRole } from 'providers/user/user-role.enum';
import React from 'react';
import { useCurrentRoute, useNavigation } from 'react-navi';

type ApiAccessRouteData = {
  companyId?: number;
  returnTo?: string;
};

const fallbackReturnTo = '/producer/my-company/tools';

const getSafeReturnTo = (returnTo: string | undefined): string => {
  if (
    !returnTo
    || !returnTo.startsWith('/')
    || returnTo.startsWith('//')
    || returnTo.includes('://')
  ) {
    return fallbackReturnTo;
  }

  return returnTo;
};

const getCompanyId = (value: unknown): number | undefined => {
  const numericValue = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(numericValue) ? numericValue : undefined;
};

export const ApiAccess: React.FC = () => {
  const navigation = useNavigation();
  const route = useCurrentRoute();
  const { query } = navigation.getCurrentValue().url;
  const routeData = route.data as ApiAccessRouteData | undefined;
  const companyId = getCompanyId(routeData?.companyId ?? query.companyId);
  const returnTo = routeData?.returnTo || (typeof query.returnTo === 'string' ? query.returnTo : undefined);
  const backRoute = getSafeReturnTo(returnTo);

  return (
    <>
      <BackToAnywhere locationName='Company' route={backRoute} />
      <AuthorizedContent roles={[UserRole.CompanyUser]}>
        <div className='sg-flock-profile-report-bar'>
          <Container className='sg-flock-profile-report__container'>
            <h2>API Access</h2>
          </Container>
        </div>
        <br />
        <Container className='sg-flock-profile__container'>
          <Card>
            {companyId ? (
              <ManageCompanySettings companyId={companyId} />
            ) : (
              <Alert severity='info'>
                API access settings are unavailable until a company is selected.
              </Alert>
            )}
          </Card>
        </Container>
      </AuthorizedContent>
    </>
  );
};

export default ApiAccess;
